module.exports = __webpack_public_path__ + "static/img/logo-bpd.6edc278.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/logo-bpd.png
// module id = y/hn
// module chunks = 0